import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import Agenda from "@/components/Agenda.vue";
import moment from 'moment';
import OperatingHoursMapper from "@/classes/OperatingHoursMapper";
import { database } from "@/plugins/firebase";
let Dashboard = class Dashboard extends Vue {
    restrictions = [];
    contacts = [];
    guides = [];
    openRestrictions = 0;
    openGuide = 0;
    get date() {
        const today = moment();
        if (today.hour() < 16) {
            return today;
        }
        return today.add('1', 'day');
    }
    get hours() {
        const hours = OperatingHoursMapper.getByDay(this.date);
        return {
            min: hours.openFrom,
            max: hours.openTo,
        };
    }
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    async created() {
        const collection = await database.collection('dashboard');
        let document = await collection.doc('guides').get();
        let data = await document.data();
        if (data) {
            this.guides = data.list.filter((guide) => guide.show <= this.$store.getters['user/role']);
        }
        document = await collection.doc('restrictions').get();
        data = await document.data();
        if (data) {
            this.restrictions = data.list;
        }
        document = await collection.doc('contacts').get();
        data = await document.data();
        if (data) {
            this.contacts = data.list;
        }
    }
};
Dashboard = __decorate([
    Component({
        components: { Agenda }
    })
], Dashboard);
export default Dashboard;
